// extracted by mini-css-extract-plugin
export default {"classroomCards":"classroomCards__skYcb","warningContainer":"warningContainer__Uuxkq","modalFooter":"modalFooter__DOg7k"};